import { FC } from 'react';
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  HStack,
  PopoverBody,
  PopoverCloseButton,
  PopoverArrow,
  PopoverContent,
  Portal,
  PopoverTrigger,
  Popover,
  Button,
  Image,
} from '@chakra-ui/react';
import { FaEdit, FaTrash } from 'react-icons/fa';
import { generatePath, Link, useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../../consts/routes';
import { useAdminCardDecksVariants } from '@olagg/api-hooks';
import { CardDeckVariant, PermissionEnum, OlaggModule } from '@olagg/db-types';
import useRoles from '../../../features/Roles/hooks/useRoles';

interface VariantsTableProps {
  variants: CardDeckVariant[];
  onUpdate: () => void;
}

const VariantsTable: FC<VariantsTableProps> = ({ variants, onUpdate }) => {
  const navigate = useNavigate();
  const { deck_id, trait_id } = useParams();
  const { missingPermission } = useRoles();
  
  if (!deck_id || !trait_id) return null;

  const { deleteVariant } = useAdminCardDecksVariants(deck_id, trait_id);

  return (
    <Table
      variant="striped"
      colorScheme="olaggPurple"
      fontSize="18px"
      position='relative'
    >
      <Thead position='sticky' top='0' bg='black' zIndex='1'>
        <Tr>
          <Th>Nombre</Th>
          <Th>Descripcion</Th>
          <Th>Probabilidad</Th>
          <Th>Imagen</Th>
          <Th>Acciones</Th>
        </Tr>
      </Thead>
      <Tbody>
        {variants.map((variant) => (
          <Tr key={variant.id}>
            <Td>{variant.name}</Td>
            <Td>{variant.description}</Td>
            <Td>{variant.probability}</Td>
            <Td>
              <a href={variant.imageUrl} target='_blank'>
                <Image src={variant.imageUrl} objectFit='contain' w='50' h='75' borderWidth='1px' borderColor='#fff' />
              </a>
            </Td>
            <Td>
              <HStack spacing={2}>
                <Button size={'sm'} padding='14px 16px' colorScheme='green'
                  onClick={(e) => { e.stopPropagation(); navigate(generatePath(ROUTES.CARD_DECKS.variants.update, { deck_id, trait_id, id: variant.id })); }}
                  leftIcon={<FaEdit />}
                  isDisabled={missingPermission(OlaggModule.CardDeck, PermissionEnum.EDIT)}
                  >
                  Editar
                </Button>
                      
                <Popover>
                  <PopoverTrigger>
                    <Button
                      size={'sm'} padding='14px 16px' ml={0} colorScheme="red"
                      onClick={(e) => e.stopPropagation()}
                      leftIcon={<FaTrash />}
                      isDisabled={missingPermission(OlaggModule.CardDeck, PermissionEnum.DELETE)}
                    >
                      Eliminar
                    </Button>
                  </PopoverTrigger>
                  <Portal>
                    <PopoverContent>
                      <PopoverArrow />
                      <PopoverCloseButton />
                      <PopoverBody>
                        <Button width={'100%'} colorScheme='red'
                          onClick={async (e) => { e.stopPropagation(); await deleteVariant(variant.id); onUpdate(); }}
                        >
                          Confirmar Eliminar
                        </Button>
                      </PopoverBody>
                    </PopoverContent>
                  </Portal>
                </Popover>
              </HStack>
            </Td>
          </Tr>
        ))}
      </Tbody>
    </Table>
  );
};

export default VariantsTable; 